
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { BaseService } from '../services/base.service';

import { ENVIRONMENT } from '../../environments/environment';

@Injectable()
export class DepositService {
  constructor(
    private baseService: BaseService
  ) {
  }

  getBankList(): Observable<Array<any>> {
    const url = ENVIRONMENT.service.bankIntegrationService + '/v1/fpx/bank_list';
    return this.baseService.get(url).pipe(catchError(this.baseService.errorHandler));
  }

  createFPXTransaction(txnData: object): Observable<object> {
    const url = ENVIRONMENT.service.bankIntegrationService + '/v1/fpx/instantPay/new';
    return this.baseService.post(url, txnData).pipe(catchError(this.baseService.errorHandler));
  }

  startFPXTransaction(txnData) {
    const url = ENVIRONMENT.service.bankIntegrationService + '/v1/fpx/instantPay/start';
    return this.baseService.post(url, txnData).pipe(catchError(this.baseService.errorHandler));
  }
}
